import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";
import InstantContact from "../InstantContact/InstantContact";
import HoldPage from "../HoldPage/HoldPage";

const Layout = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isDriverRoute = location.pathname.startsWith("/driver"); // Check for driver routes

  return (
    <Fragment>
      {/* Render Header, Footer, and InstantContact only if not on admin or driver routes */}
      {/* {!isAdminRoute && !isDriverRoute && <Header />}
      <div>
        <Routers />
      </div>
      {!isAdminRoute && !isDriverRoute && <Footer />}
      {!isAdminRoute && !isDriverRoute && <InstantContact />} */}
      <div>
        <HoldPage />
      </div>
    </Fragment>
  );
};

export default Layout;